import {h, Fragment} from "preact"
import { useSort } from "@nosto/preact";
import { useState } from "preact/hooks";
import { sortOptions } from "../../config"

export default function SelectInsideSidebar({ value, className, options, label }) {
    console.log("INSIDE SORTING COMPONENT");
    const [isActive, setIsActive] = useState(false);

    const { activeSort, setSort } = useSort(sortOptions)

    const activeSortName = sortOptions.find(opt => opt.id === activeSort)?.value.name;


    const handleSortChange = event => {
        const componentContainer = event.currentTarget.closest('.ns-sidebar-dropdown');
        
        const checkboxes = componentContainer.querySelectorAll('input[type="checkbox"]');
        checkboxes.forEach(checkbox => {
            checkbox.checked = false;
        });
        
        const clickedCheckbox = event.currentTarget.querySelector('input[type="checkbox"]');
        if (clickedCheckbox) {
            clickedCheckbox.checked = true;
        }
        
        setSort(event.target.getAttribute("value"))
    }

    console.log("OPTIONS", activeSort, options);

    return (
            <li class={`ns-sidebar-dropdown ${isActive ? "ns-active" : ""}`} aria-expanded="false" onClick={() => setIsActive(!isActive)}>
            <span class="ns-anchor ns-d-inline-block ns-relative ns-w-100 ns-border-box ns-p-4 facet-group__header" data-nosto-element="facet" aria-controls="67e5fd9c41ccc46756df7350-sub-menu" aria-label="Expand sorting options">
            <h4 class="ns-color-black ns-font-4">Sort by</h4>
            <i class="ns-icon ns-icon-arrow ns-absolute"></i>
            </span>
            <div class="ns-sidebar-submenu ns-d-none ns-p-4">
                <ul role="menu" class="ns-list-unstyled ns-p-0 ns-m-0" role="menu">
                {options.map(option => (
                    <li key={option.value} data-nosto-element="facet-setting" role="menuitem" class="ns-d-flex ns-justify-content-between ns-align-items-center ns-font-3">
                        <label value={option.value} onClick={e => handleSortChange(e)} class={`ns-checkbox ns-d-block ns-color-black undefined nosto-facet ${activeSort == option.value ? ' ns-active ' : ' '}`}>{option.label}
                        <input type="checkbox" checked={option.value == activeSort}/>
                        <span class="ns-checkmark"></span>
                        </label>
                    </li>
                ))}
                </ul>
            </div>
            </li>
    )
}
